/**
* @Description: 下载geoJson文件
* @Author: TSY
* @CreateDate: 2018/9/5 9:04
* @email: t@tsy6.com
*/
<template>
  <div class="body">
    <div class="map">
      <map-range :download-tips="downloadTips" :loading="isLoading" :show-city-select="showCitySelect" @change="search"
        @click="downloadJson"></map-range>
    </div>
    <div class="container">
      <div class="left-panel">
        <div id="amap-container"></div>
      </div>
      <div class="right-panel">
        <div id="map"></div>
      </div>
    </div>
    <div class="tips" v-show="isShowTips">
      正在下载，请耐心等待。。。(可打开控制台查看进度详情)
    </div>
    <!--哎呀呀，这就是打赏弹窗，为方便你们删除，就单独抽出一个组件来吧-->
    <money-dialog ref="dialog" @confirm="dialogConfirm"></money-dialog>
    <!--github入口-->
    <github></github>
    <!-- 地图位 -->
    <div class="map-link" v-if="isShowMap">
      <div class="map-link-close" @click="isShowMap = false"></div>
      <a href="https://map.hxkj.vip" target="_blank">
        <img :src="MAP_IMG" alt="地图" />
      </a>
    </div>
    <!--乡镇数据弹窗-->
    <street-dialog ref="streetDialog" @confirm="contact"></street-dialog>
    <!--乡镇级联数据下载弹窗-->
    <map-data-dialog ref="mapDataDialog" @confirm="contact"></map-data-dialog>
  </div>
</template>

<script>
import saveAs from "./saveAs";
import MapRange from "./MapRange";
import MoneyDialog from "./MoneyDialog";
import StreetDialog from "./StreetDialog";
import mapDataDialog from "./mapDataDialog";
import Github from "./Github";
import { MAP_IMG } from "./images/mapimg";
import {
  queryGeoJson,
  queryChildrenGeoJson,
  queryDistrictChildren,
} from "./api/mapService";

export default {
  name: "demo",
  components: {
    Github,
    MoneyDialog,
    StreetDialog,
    mapDataDialog,
    MapRange,
  },
  data() {
    return {
      MAP_IMG,
      isShowMap: true,
      nameType: "",
      cityName: "中国",
      areaCode: 10000,
      geoJsonData: "",
      echartsMap: null,
      amapInstance: null, // 高德地图实例
      amapLayer: null, // 高德地图图层
      cityCode: 100000,
      provinceSelect: null,
      citySelect: null,
      districtSelect: null,
      areaData: {},
      mapData: [],
      downloadTips: "下载geoJson数据", //下载进度提示
      isShowTips: false, //是否显示下载提示
      isLoading: false, //数据加载状态
      showCitySelect: true, // 是否显示市级选择框
    };
  },
  async mounted() {
    this.provinceSelect = document.getElementById("province");
    this.citySelect = document.getElementById("city");
    this.districtSelect = document.getElementById("district");
    this.echartsMap = this.$echarts.init(document.getElementById("map"));
    this.echartsMap.on("click", this.echartsMapClick);

    // 初始化高德地图
    this.initAmap();

    // 使用新接口获取中国的下级行政区划
    this.isLoading = true;
    try {
      const districtList = await queryDistrictChildren("100000");
      if (districtList && districtList.length > 0) {
        await this.getData(
          {
            name: "中国",
            adcode: "100000",
            level: "country",
            districtList: districtList,
          },
          "",
          100000
        );
      }
    } catch (error) {
      console.error("获取行政区划数据失败:", error);
    } finally {
      this.isLoading = false;
    }
  },
  watch: {},
  methods: {
    /**
     * 初始化高德地图
     */
    initAmap() {
      // 确保AMap已加载
      if (typeof AMap === 'undefined') {
        console.error('高德地图API未加载');
        setTimeout(() => this.initAmap(), 100);
        return;
      }

      // 创建地图实例
      this.amapInstance = new AMap.Map('amap-container', {
        zoom: 4,
        center: [105.602725, 37.076636], // 中国中心点
        viewMode: '2D',
        mapStyle: 'amap://styles/normal'
      });

      console.log('高德地图初始化成功');
    },
    /**
     * 更新高德地图上的GeoJSON数据
     */
    updateAmapGeoJson(geoJson) {
      if (!this.amapInstance || !geoJson) {
        console.log('高德地图实例或GeoJSON数据不存在', {
          hasMap: !!this.amapInstance,
          hasGeoJson: !!geoJson
        });
        return;
      }

      console.log('开始渲染GeoJSON到高德地图', geoJson);

      // 移除旧图层
      if (this.amapLayer) {
        this.amapInstance.remove(this.amapLayer);
        this.amapLayer = null;
      }

      // 创建多边形数组
      const overlays = [];

      try {
        // 确保是FeatureCollection格式
        const features = geoJson.type === 'FeatureCollection'
          ? geoJson.features
          : [geoJson];

        features.forEach((feature) => {
          if (!feature.geometry) return;

          const { type, coordinates } = feature.geometry;

          if (type === 'Polygon') {
            // 处理Polygon
            const polygon = new AMap.Polygon({
              path: coordinates[0].map(coord => [coord[0], coord[1]]),
              strokeColor: '#3366FF',
              strokeWeight: 2,
              fillColor: '#80d8ff',
              fillOpacity: 0.35,
              strokeStyle: 'solid'
            });
            overlays.push(polygon);
          } else if (type === 'MultiPolygon') {
            // 处理MultiPolygon
            coordinates.forEach((polygonCoords) => {
              const polygon = new AMap.Polygon({
                path: polygonCoords[0].map(coord => [coord[0], coord[1]]),
                strokeColor: '#3366FF',
                strokeWeight: 2,
                fillColor: '#80d8ff',
                fillOpacity: 0.35,
                strokeStyle: 'solid'
              });
              overlays.push(polygon);
            });
          }
        });

        // 添加所有多边形到地图
        if (overlays.length > 0) {
          this.amapInstance.add(overlays);
          this.amapLayer = overlays;

          // 自动缩放到合适的视野
          this.amapInstance.setFitView(overlays);

          console.log(`成功渲染${overlays.length}个多边形到高德地图`);
        } else {
          console.warn('没有找到可渲染的多边形数据');
        }
      } catch (error) {
        console.error('渲染GeoJSON到高德地图失败:', error);
      }
    },
    /**
     * 同步级联选择器的选中状态
     * @param {String} level 级别（province/city/district）
     * @param {String} name 区域名称
     * @param {String} adcode 区域代码
     */
    syncCascaderSelection(level, name, adcode) {
      let selectElement = null;

      // 根据级别找到对应的select元素
      if (level === "province") {
        selectElement = this.provinceSelect;
      } else if (level === "city") {
        selectElement = this.citySelect;
      } else if (level === "district") {
        selectElement = this.districtSelect;
      }

      if (!selectElement || !selectElement.options) return;

      // 在select的options中查找匹配的选项
      for (let i = 0; i < selectElement.options.length; i++) {
        const option = selectElement.options[i];
        if (option.adcode === adcode || option.text === name) {
          selectElement.selectedIndex = i;
          break;
        }
      }
    },
    /**
     * 确保 GeoJSON 是标准的 FeatureCollection 格式
     * @param {Object} geoJson GeoJSON 数据
     * @returns {Object} 标准的 FeatureCollection
     */
    ensureFeatureCollection(geoJson) {
      if (!geoJson) return null;

      // 如果已经是 FeatureCollection，直接返回
      if (geoJson.type === "FeatureCollection" && geoJson.features) {
        return geoJson;
      }

      // 如果是单个 Feature，包装成 FeatureCollection
      if (geoJson.type === "Feature") {
        return {
          type: "FeatureCollection",
          features: [geoJson],
        };
      }

      // 如果有 geometry 属性，说明是 Feature 格式（缺少 type）
      if (geoJson.geometry) {
        return {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              ...geoJson,
            },
          ],
        };
      }

      // 其他情况，原样返回
      return geoJson;
    },
    async echartsMapClick(params) {
      //地图点击事件
      this.$ba &&
        this.$ba.trackEvent(
          "echartsMap",
          "点击地图",
          `${params.data.name}-${params.data.cityCode}`
        );
      if (params.data.level == "street") return;
      this.cityName = params.data.name;
      this.cityCode = params.data.cityCode;

      // 同步级联选择器的选中状态
      this.syncCascaderSelection(
        params.data.level,
        params.data.name,
        params.data.cityCode
      );

      this.isLoading = true;
      try {
        // 区县级别：只查询自己的边界，不加载下级
        if (params.data.level === "district") {
          let geoJson = await queryGeoJson(this.cityCode);
          if (geoJson) {
            // 确保数据是标准的 FeatureCollection 格式
            geoJson = this.ensureFeatureCollection(geoJson);

            //添加 site 属性
            if (geoJson.features && geoJson.features.length) {
              geoJson.features.forEach(
                (item) => (item.properties.site = "https://geojson.hxkj.vip")
              );
            }
            this.mapData = [
              {
                name: this.cityName,
                value: Math.random() * 100,
                cityCode: this.cityCode,
                level: "district",
              },
            ];
            this.geoJsonData = geoJson;

            // 渲染到 ECharts 地图
            this.loadMap(this.cityName, geoJson);
          }
        } else {
          // 其他级别：查询下级行政区划
          const districtList = await queryDistrictChildren(this.cityCode);

          // 如果没有下级行政区划数据（如台湾省），直接显示自身边界
          if (!districtList || districtList.length === 0) {
            let geoJson = await queryGeoJson(this.cityCode);
            if (geoJson) {
              // 确保数据是标准的 FeatureCollection 格式
              geoJson = this.ensureFeatureCollection(geoJson);

              //添加 site 属性
              if (geoJson.features && geoJson.features.length) {
                geoJson.features.forEach(
                  (item) => (item.properties.site = "https://geojson.hxkj.vip")
                );
              }
              this.mapData = [
                {
                  name: this.cityName,
                  value: Math.random() * 100,
                  cityCode: this.cityCode,
                  level: params.data.level,
                },
              ];
              this.geoJsonData = geoJson;

              // 渲染到 ECharts 地图
              this.loadMap(this.cityName, geoJson);
            }
          } else {
            // 有下级行政区划数据，正常加载
            await this.getData(
              {
                name: this.cityName,
                adcode: this.cityCode,
                level: params.data.level,
                districtList: districtList,
              },
              params.data.level,
              this.cityCode
            );
          }
        }
      } catch (error) {
        console.error("查询行政区划失败:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async loadMapData(areaCode) {
      try {
        // 使用新接口查询下级所有区划的轮廓
        const mapJson = await queryChildrenGeoJson(areaCode);

        //添加 site 属性
        if (mapJson && mapJson.features && mapJson.features.length) {
          mapJson.features.forEach(
            (item) => (item.properties.site = "https://geojson.hxkj.vip")
          );
        }

        // 渲染到 ECharts 地图
        this.loadMap(this.cityName, mapJson);

        // 保存数据
        this.geoJsonData = mapJson;
      } catch (error) {
        console.error("加载地图数据失败:", error);
      }
    },
    showTips() {
      this.isShowTips = true;
      setTimeout(() => {
        this.isShowTips = false;
      }, 3000);
    },
    downloadJson(nameType) {
      //geo文件下载
      this.nameType = nameType;
      if (nameType === "area") {
        this.$ba &&
          this.$ba.trackEvent("echartsMap", "文件下载", "下载级联数据");
        this.$refs.dialog.show();
        return;
      }
      if (nameType === "street") {
        this.$ba &&
          this.$ba.trackEvent("echartsMap", "文件下载", "下载乡镇数据");
        this.$refs.streetDialog.show();
        return;
      }
      var blob = new Blob([JSON.stringify(this.geoJsonData)], {
        type: "text/plain;charset=utf-8",
      });
      let filename = this.cityName;
      if (nameType === "code") {
        filename = this.cityCode;
      }
      this.$ba && this.$ba.trackEvent("echartsMap", "文件下载", filename);
      saveAs(blob, `${filename}.geoJson`); //filename
    },
    dialogConfirm() {
      if (this.nameType === "area") {
        this.$refs.mapDataDialog.show();
      }
    },
    loadMap(mapName, data) {
      if (data) {
        // 更新高德地图
        this.updateAmapGeoJson(data);

        // 更新ECharts地图
        this.$echarts.registerMap(mapName, data);
        var option = {
          visualMap: {
            type: "piecewise",
            pieces: [
              { max: 30, label: "安全", color: "#2c9a42" },
              { min: 30, max: 60, label: "警告", color: "#d08a00" },
              { min: 60, label: "危险", color: "#c23c33" },
            ],
            color: "#fff",
            textStyle: {
              color: "#fff",
            },
            visibility: "off",
          },
          series: [
            {
              name: "数据名称",
              type: "map",
              roam: false,
              mapType: mapName,
              selectedMode: "single",
              showLegendSymbol: false,
              visibility: "off",
              itemStyle: {
                normal: {
                  color: "#ccc",
                  areaColor: "#fff",
                  borderColor: "#fff",
                  borderWidth: 0.5,
                  label: {
                    show: true,
                    textStyle: {
                      color: "rgb(249, 249, 249)",
                    },
                  },
                },
                emphasis: {
                  areaColor: false,
                  borderColor: "#fff",
                  areaStyle: {
                    color: "#fff",
                  },
                  label: {
                    show: true,
                    textStyle: {
                      color: "rgb(249, 249, 249)",
                    },
                  },
                },
              },
              data: this.mapData,
            },
          ],
        };
        this.echartsMap.setOption(option);
      }
    },
    async getData(data, level, adcode) {
      // 注意：新的 API (queryDistrictChildren) 不返回 boundaries 属性
      // 边界渲染已在 loadMapData 方法中处理

      //清空下一级别的下拉列表
      if (level === "province") {
        this.citySelect.innerHTML = "";
        this.districtSelect.innerHTML = "";
      } else if (level === "city") {
        this.districtSelect.innerHTML = "";
      }

      var subList = data.districtList;
      if (subList) {
        var contentSub = new Option("--请选择--");
        var curlevel = subList[0].level;

        // 根据下级行政区划级别动态控制市级选择框的显示
        if (level === "province" || level === "country") {
          // 如果当前是省级或国家级，且下级直接是district，说明没有市级（如香港、澳门）
          this.showCitySelect = curlevel !== "district";
        }
        if (curlevel === "street") {
          let mapJsonList = this.geoJsonData.features;
          let mapJson = {};
          for (let i in mapJsonList) {
            if (mapJsonList[i].properties.name == this.cityName) {
              mapJson.type = "FeatureCollection";
              mapJson.features = [].concat(mapJsonList[i]);
            }
          }
          this.mapData = [];
          this.mapData.push({
            name: this.cityName,
            value: Math.random() * 100,
            level: curlevel,
          });
          this.loadMap(this.cityName, mapJson);
          return;
        }

        var curList = document.querySelector("#" + curlevel);
        curList.add(contentSub);
        this.mapData = [];
        for (var i = 0, l = subList.length; i < l; i++) {
          var name = subList[i].name;
          var cityCode = subList[i].adcode;
          this.mapData.push({
            name: name,
            value: Math.random() * 100,
            cityCode: cityCode,
            level: curlevel,
          });
          var levelSub = subList[i].level;
          contentSub = new Option(name);
          contentSub.setAttribute("value", levelSub);
          contentSub.center = subList[i].center;
          contentSub.adcode = subList[i].adcode;
          curList.add(contentSub);
        }
        await this.loadMapData(adcode);
        this.areaData[curlevel] = curList;
      }
    },
    async search(area) {
      let obj = this.areaData[area];
      var option = obj[obj.options.selectedIndex];
      var keyword = option.text; //关键字
      var adcode = option.adcode;
      this.cityName = keyword;
      this.cityCode = adcode;
      this.$ba &&
        this.$ba.trackEvent(
          "echartsMap",
          "筛选地图",
          `${this.cityName}-${this.cityCode}`
        );

      // 切换省份时，清空市级和区级选择框
      if (area === "province") {
        this.citySelect.innerHTML = "";
        this.districtSelect.innerHTML = "";
        this.citySelect.selectedIndex = -1;
        this.districtSelect.selectedIndex = -1;
      }
      // 切换市级时，清空区级选择框
      else if (area === "city") {
        this.districtSelect.innerHTML = "";
        this.districtSelect.selectedIndex = -1;
      }

      this.isLoading = true;
      try {
        // 区县级别：只查询自己的边界，不加载下级
        if (option.value === "district") {
          let geoJson = await queryGeoJson(adcode);
          if (geoJson) {
            // 确保数据是标准的 FeatureCollection 格式
            geoJson = this.ensureFeatureCollection(geoJson);

            //添加 site 属性
            if (geoJson.features && geoJson.features.length) {
              geoJson.features.forEach(
                (item) => (item.properties.site = "https://geojson.hxkj.vip")
              );
            }
            this.mapData = [
              {
                name: keyword,
                value: Math.random() * 100,
                cityCode: adcode,
                level: "district",
              },
            ];
            this.geoJsonData = geoJson;

            // 渲染到 ECharts 地图
            this.loadMap(keyword, geoJson);
          }
        } else {
          // 其他级别：查询下级行政区划
          const districtList = await queryDistrictChildren(adcode);

          // 如果没有下级行政区划数据（如台湾省），直接显示自身边界
          if (!districtList || districtList.length === 0) {
            let geoJson = await queryGeoJson(adcode);
            if (geoJson) {
              // 确保数据是标准的 FeatureCollection 格式
              geoJson = this.ensureFeatureCollection(geoJson);

              //添加 site 属性
              if (geoJson.features && geoJson.features.length) {
                geoJson.features.forEach(
                  (item) => (item.properties.site = "https://geojson.hxkj.vip")
                );
              }
              this.mapData = [
                {
                  name: keyword,
                  value: Math.random() * 100,
                  cityCode: adcode,
                  level: option.value,
                },
              ];
              this.geoJsonData = geoJson;

              // 渲染到 ECharts 地图
              this.loadMap(keyword, geoJson);
            }
          } else {
            // 有下级行政区划数据，正常加载
            await this.getData(
              {
                name: keyword,
                adcode: adcode,
                level: option.value,
                districtList: districtList,
              },
              obj.id,
              adcode
            );
          }
        }
      } catch (error) {
        console.error("查询行政区划失败:", error);
      } finally {
        this.isLoading = false;
      }
    },
    // 联系下载乡镇数据
    contact() {
      this.$ba && this.$ba.trackEvent("echartsMap", "文件下载", "联系下载");
      if (/(iPhone|iPad|iPod|iOS|android)/i.test(navigator.userAgent)) {
        window.open(
          "mqqwpa://im/chat?chat_type=wpa&uin=2890228902&version=1&src_type=web&web_src=http:://wpa.b.qq.com"
        );
      } else {
        window.open(
          "http://wpa.qq.com/msgrd?v=3&uin=2890228902&site=在线客服&menu=yes"
        );
      }
    },
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}
</style>

<style lang="stylus" scoped>
* {
  font-size: 14px;
}

.body {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.map {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
}

.container {
  display: flex;
  width: 100%;
  height: 100%;
}

.left-panel {
  width: 50%;
  height: 100%;
  position: relative;
}

.right-panel {
  width: 50%;
  height: 100%;
  position: relative;
  background: url('./images/bg_bigdata.png') no-repeat;
  background-size: 100% 100%;
}

#amap-container {
  width: 100%;
  height: 100vh;
}

#map {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.tips {
  position: fixed;
  bottom: 30%;
  left: 40%;
  padding: 10px 15px;
  border-radius: 5px;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
}

.map-link {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  cursor: pointer;
  width: 320px;

  a {
    display: block;
    width: 320px;
  }

  img {
    width: 320px;
    display: block;
  }
}

.map-link-close {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
}

@keyframes mapShakeAnmation {
  0% {
    bottom: 1px;
    left: 0px;
  }

  30% {
    bottom: 1;
    left: 10px;
  }

  70% {
    bottom: 0px;
    left: 1px;
  }

  100% {
    bottom: 0;
    left: 0;
  }
}
</style>
